import { render, staticRenderFns } from "./log-live.vue?vue&type=template&id=3d253afe"
import script from "./log-live.ts?vue&type=script&lang=js&external"
export * from "./log-live.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports